import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { AssetAssignmentService } from '../../services/asset-assignment.service';
import { AssetAssignment } from '../../models/entities/asset-assignment';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { BranchLovComponent } from 'src/app/assabil-admin/components/control-tables/branch/branch-lov/branch-lov.component';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { Field } from 'src/app/tools/models/dtos/field';
import { PartnerLovComponent } from 'src/app/assabil-admin/components/master-data/partner/partner-lov/partner-lov.component';
import { RoleLovComponent } from 'src/app/assabil-admin/components/master-data/role/role-lov/role-lov.component';
import { PersonLovComponent } from 'src/app/assabil-admin/components/master-data/person/person-lov/person-lov.component';
import { AssetProductLov } from '../asset-product-lov/asset-product-lov.component';
import { AssetShipment } from '../../models/entities/asset-shipment';
import { marker } from 'src/app/tools/models/entities/marker';
import { AssetShipmentService } from '../../services/asset-shimpnent.service';
import { AssetAssignmentPipe } from '../../pipes/asset-assignment-pipe';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';


@Component({
    selector: 'asset-assignment-list',
    templateUrl: './asset-assignment-list.component.html',
    styleUrls: ['./asset-assignment-list.component.scss']
})


export class AssetAssignmentListComponent extends BasePage2<AssetAssignment> {


    assetAssignmentCode   : string;
    assetOrderCode        : string;
    startDate             : Date;
    endDate               : Date;
    relatedBranch         : string;
    assetAssignmentType   : string;

    plInitial             : boolean = true;
    plSent                : boolean = true;
    plReceived            : boolean = true;
 
    pl_newly_created      : boolean = true;
    pl_confirmed          : boolean = true;
    pl_contract_submitted : boolean = true;
    pl_contract_signed    : boolean = true;
    pl_shipment_planed    : boolean = true;
    pl_shipped            : boolean = true;
    pl_delivered          : boolean = true;
    pl_operating          : boolean = true;
    pl_redeploy_requested : boolean = true;
    pl_return_requested   : boolean = true; 
    pl_return_validated   : boolean = true;
    pl_return_confirmed   : boolean = true;

    
    branchLovComponent    = BranchLovComponent;
    assetAssignments      : AssetAssignment[] = [];

    branch                : Branch;
    dispatchMode          : boolean = false;
    assetShipmentCode     : string;

    assetShipments        : AssetShipment[] = [];
    assetTransferPipe     : AssetAssignmentPipe = new AssetAssignmentPipe();

    constructor(
      protected assetAssignmentService: AssetAssignmentService,
      protected assetShipmentService  : AssetShipmentService,
      protected toastr                : ToastrService,
      protected router                : Router,
      protected baseService           : BaseService,
      public    leanUtilsService      : LeanUtilsService, 
      protected dialog                : MatDialog,
      protected location              : Location,
      protected activatedRoute        : ActivatedRoute,
      private loading                 : NgxSpinnerService) {
      super(toastr, router, baseService, leanUtilsService, location);
      this.entityName = 'assetAssignment';
    }


//--------------------------------------------------------------------------------------------------------
  ngOnInit() {
    super.ngOnInit();
    let assetShipmentCode : string;
    let branchCode        : string = null;
    let progressLevels    : boolean[] = [true, false, false];

    this.assetShipmentService.assetShipmentsGet(    
                                  assetShipmentCode,
                                  branchCode       ,
                                  progressLevels   ).then(assetShipments => {
      this.assetShipments = assetShipments;

    });    
  }
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
  getRows(): AssetAssignment[] {
      return this.assetAssignments;
  }
//--------------------------------------------------------------------------------------------------------



//-----------------------------------------------------------------------------------------------------------------------------
newAssetAssignment(){
  let dialogRef = this.dialog.open(AssetProductLov);
  dialogRef.afterClosed().subscribe(result => {
    if(result){
      this.showPartnerLov(result);
    }
  });
}
//-----------------------------------------------------------------------------------------------------------------------------


//-----------------------------------------------------------------------------------------------------------------------------
partners : Partner[];
showPartnerLov(assetProduct : AssetProduct){
  let dialogRef = this.dialog.open(PartnerLovComponent, {autoFocus: false,  hasBackdrop : false,  data : {dual : true, partners : this.partners }});
  dialogRef.afterClosed().subscribe(result => {
    if(result){
      this.partners = result.partners;
      if (result.selectedPartners) this.addPartners(assetProduct, result.selectedPartners);
    }
  });
}
//-----------------------------------------------------------------------------------------------------------------------------

//-----------------------------------------------------------------------------------------------------------------------------
addPartners(assetProduct : AssetProduct, partners : Partner[]){
  let partnerCodes : string[] = [];
  for (let partner of partners){
    partnerCodes.push(partner.partnerCode);
  }
  this.assetAssignmentService.assetAssignmentsAdd(assetProduct.assetProductCode, partnerCodes).then(assetAssignments => {
    this.assetAssignments = assetAssignments;
    this.toastr.success('Opération effectuée avec succès');
  });
}
//-----------------------------------------------------------------------------------------------------------------------------



//-----------------------------------------------------------------------------------------------------------------------------
loadData() {
 
  let branchCode      : string = null;
  let partnerCode     : string;
  let assetProductCode: string; 
  let assetCode       : string; 
  let barCode         : string; 
  let startDate       : Date;
  let endDate         : Date;
  let booleans        : boolean[] = [];

  booleans.push(this.pl_newly_created          );
  booleans.push(this.pl_confirmed              );
  booleans.push(this.pl_contract_submitted     );
  booleans.push(this.pl_contract_signed        );
  booleans.push(this.pl_shipment_planed        );
  booleans.push(this.pl_shipped                );
  booleans.push(this.pl_delivered              );
  booleans.push(this.pl_operating              );
  booleans.push(this.pl_redeploy_requested     );
  booleans.push(this.pl_return_requested       );
  booleans.push(this.pl_return_validated       );
  booleans.push(this.pl_return_confirmed       );
  

  if (this.branch) branchCode = this.branch.branchCode;

  this.assetAssignmentService.assetAssignmentsGet(
    booleans,
    branchCode      ,
    partnerCode     ,
    assetProductCode,
    assetCode       ,
    barCode         ,
    startDate       ,
    endDate         ).then(result => {
      this.assetAssignments = result;
  });
}
//--------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
selectRow(assetAssignment : AssetAssignment){
  if (this.dispatchMode) {
    assetAssignment.selected = ! assetAssignment.selected;

    let index = this.assetAssignments.indexOf(assetAssignment);
    let point   : marker = this.points[index];
    if (this.assetAssignments[index].selected) {
      point.iconUrl = 'http://maps.google.com/mapfiles/ms/icons/red.png';
    }else {
      point.iconUrl = 'http://maps.google.com/mapfiles/ms/icons/green.png';
    }

  } else {
    this.selectedRow = assetAssignment;
  }
}
//--------------------------------------------------------------------------------------------------------



//--------------------------------------------------------------------------------------------------------
enrichField(field : Field){
  if (field.prop == 'partner') { field.modal = PartnerLovComponent; field.subProp = 'name';}
  
  if (field.prop == 'branch')  { field.modal = BranchLovComponent;  field.subProp = 'name';}
  if (field.prop == 'role')    { field.modal = RoleLovComponent;    field.subProp = 'name';}
  if (field.prop == 'person')  { field.modal = PersonLovComponent;  field.subProp = 'name';}

  if (field.prop == 'expeditionPerson')           { field.modal = PersonLovComponent;  field.subProp = 'name';}
  if (field.prop == 'confirmationPerson')         { field.modal = PersonLovComponent;  field.subProp = 'name';}
  if (field.prop == 'receptionPerson')            { field.modal = PersonLovComponent;  field.subProp = 'name';}
  if (field.prop == 'installConfirmationPerson')  { field.modal = PersonLovComponent;  field.subProp = 'name';}

  if (field.prop == 'returnRequestPerson')  { field.modal = PersonLovComponent;  field.subProp = 'name';}
  if (field.prop == 'returnValidationPerson')  { field.modal = PersonLovComponent;  field.subProp = 'name';}
  if (field.prop == 'returnConfirmationPerson')  { field.modal = PersonLovComponent;  field.subProp = 'name';}


  if (field.prop == 'progressLevel')  { field.pipe = this.assetTransferPipe}


  //if (field.prop == 'assetAssignmentTerminationType')     { field.modal = AssetAssignmentTerminationTypeLovComponent;  field.subProp = 'name';}
  if (field.prop == 'assetProduct') { field.modal = AssetProductLov; field.subProp = 'name';}
  //if (field.prop == 'asset') { field.modal = AssetLovComponent; field.subProp = 'name';}
  
}
//--------------------------------------------------------------------------------------------------------

originalListFields = [];
//--------------------------------------------------------------------------------------------------------
shwitchDispatchMode(b : boolean){
  this.dispatchMode = b;
  if (b) {
    this.buildPoints();
    this.originalListFields = this.listFields;
    
    let tmp  = [  
      { prop: 'selected',     name: 'S', type : 'boolean' }
    ]

 
    let field : Field;
    field  =  this.listFields.find(f => (f.prop == 'assetAssignmentCode'));               if (field) tmp.push(field);
    field  =  this.listFields.find(f => (f.prop == 'contractSignatureDate'));             if (field) tmp.push(field);
    field  =  this.listFields.find(f => (f.prop == 'partner.name'));                      if (field) tmp.push(field);
    field  =  this.listFields.find(f => (f.prop == 'assetProduct.name'));                 if (field) tmp.push(field);
    field  =  this.listFields.find(f => (f.prop == 'assetShipment.assetShipmentCode'));   if (field) tmp.push(field);
    field  =  this.listFields.find(f => (f.prop == 'progressLevel'));                     if (field) tmp.push(field);
    field  =  this.listFields.find(f => (f.prop == 'branch.name'));                       if (field) tmp.push(field);
    this.listFields = tmp;
  } else {
    this.listFields = this.originalListFields;
  }
}
//--------------------------------------------------------------------------------------------------------

setShipment(){
  if (! this.assetShipmentCode) {
    this.leanUtilsService.error("Prière de renseigner le code Expédition");
    return;
  }
  let assetAssignmentCodes : string[] = [];
  let assetShipment        : AssetShipment = new AssetShipment();
  assetShipment.assetShipmentCode = this.assetShipmentCode;
  for (let assetAssignment of this.assetAssignments){
    if (assetAssignment.selected) {
      assetAssignment.assetShipment = assetShipment;
      assetAssignmentCodes.push(assetAssignment.assetAssignmentCode);
    }
  }

  this.assetAssignmentService.assetAssignmentsShipmentSet(this.assetShipmentCode, assetAssignmentCodes).then(result => {
      this.leanUtilsService.success();
  });
}
//--------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------
points : marker[] = [];
buildPoints(){
  this.points = [];
  let i : number = 0;
  this.assetAssignments.forEach(assetAssignment => {

    let point : marker = {     
      lat       : assetAssignment.partner.latitude,
      lng       : assetAssignment.partner.longitude,
      label     : assetAssignment.partner.name,
      draggable : false,
      iconUrl   : 'http://maps.google.com/mapfiles/ms/icons/green.png'
    };
  
    this.points.push(point);
  })
}

onSelectPoint(index : number) {
  this.assetAssignments[index].selected = !this.assetAssignments[index].selected 
  let point   : marker = this.points[index];
  if (this.assetAssignments[index].selected) {
    point.iconUrl = 'http://maps.google.com/mapfiles/ms/icons/red.png';
  }else {
    point.iconUrl = 'http://maps.google.com/mapfiles/ms/icons/green.png';
  }
}
//----------------------------------------------------------------------

}
